module.exports = __webpack_public_path__ + "static/media/art_fl_splash.fb59c61b.jpg";